import React from 'react'
import ImgForm from '../assets/images/contact.webp'
import Icon1 from '../assets/icons/location-circle.svg'
import Icon2 from '../assets/icons/envelop-circle.svg'
import Icon3 from '../assets/icons/phone-circle.svg'
import Icon4 from '../assets/icons/clock-circle.svg'
import ContactForm from '../components/contactForm'

const GMB_LINK = 'https://g.co/kgs/y5XJnxs'

export default function Contact () {
  return (
    <div className='px-md-3 px-lg-5 pt-2'>
      <div className='row p-2'>
        <h1 className='web-header'>Interested in Multikrd?</h1>
        <div className='large-text pt-2 pb-3'>Tell us a little more and we’ll be in touch!</div>
      </div>
      <div className='row pt-0 pt-5-md pb-2'>
        <div className='col-6 d-none d-md-inline'>
          <img src={ImgForm} alt='imgForm' />
        </div>
        <div className='col-12 col-md-6 px-5 px-md-0'>
          <ContactForm emailRecipient='support@multikrd.com' />
        </div>
      </div>
      <div className='row pt-2 pb-2 mb-5'>
        {contactInfo.map((e, index) => {
          return (
            <div key={index} className='col-12 col-sm-6 col-md-3 p-5 p-md-3 p-lg-5'>
              <div className='d-flex justify-content-start pb-4'>
                <img src={e.icon} alt={e.title} />
              </div>
              <h2 className='large-text text-start bold'>{e.title}</h2>
              <div className='text-regular text-start'>{e.text}</div>
              {index === 0 && (
                <div className='text-regular text-start'>
                  <a
                    href={GMB_LINK}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    View on Google Maps
                  </a>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

const contactInfo = [
  {
    title: 'Address',
    text: (
      <>
        10800 Gosling Rd, Box 131834 <br /> Spring TX, 77381-9998
      </>
    ),
    icon: Icon1
  },
  {
    title: 'Email',
    text: 'support@multikrd.com',
    icon: Icon2
  },
  {
    title: 'Phone',
    text: '1-866-995-2736',
    icon: Icon3
  },
  {
    title: 'Hours',
    text: <>Mon - Fri: 9am - 5pm</>,
    icon: Icon4
  }
]
